/* Code that helps calculate label positions.
 *
 * The coordinates defined here loosely follow a convention of alternative
 * left and right & up and down adjustments from the dot the label is attached to,
 * per quartile.
 *
 * Although not particularly nice, each function contributing to label coordinates
 * will return undefined if its result would otherwise be NaN or some other
 *  unsavoury value. This is important because of where they are used. In Victory,
 * providing NaNs will cause the labelling process to generate > errors
 * fairly quickly. Whilst it doesn't break the application, it slows
 * its performance down pretty quickly.
 *
 * */

/**
 * Calculates the x coordinate of the label relative to the dot.
 * @param datum {Object}
 * @returns {undefined|number}
 */
export function calculateDx(datum) {
    let dx;
    if (datum.hitRate === null) {
        return undefined;
    }
    if (
        datum.hitRate <= 0.25 ||
        (datum.hitRate > 0.5 && datum.hitRate <= 0.75)
    ) {
        dx = datum.hitRate + 8.5;
    } else {
        dx = datum.hitRate - 8.5;
    }
    if (isNaN(dx)) {
        return undefined;
    }
    return dx;
}

/**
 * Calculates the y coordinate of the label relative to the dot.
 * @param datum {Object}
 * @returns {undefined|number}
 */
export function calculateDy(datum) {
    let dy;
    if (datum.payoffTransformed === null) {
        return undefined;
    }
    if (
        datum.payoffTransformed <= 0.25 ||
        (datum.payoffTransformed > 0.5 && datum.payoffTransformed <= 0.75)
    ) {
        dy = datum.payoffTransformed - 5;
    } else {
        dy = datum.payoffTransformed + 5;
    }
    if (isNaN(dy)) {
        return undefined;
    }
    return dy;
}

/**
 * Calculates the text anchor of a dot label.
 * @param datum {Object}
 * @returns {undefined|number}
 */
export function calculateTextAnchor(datum) {
    if ((datum.hitRate ?? null) === null) {
        return undefined;
    }
    let anchor;
    if (
        datum.hitRate <= 0.25 ||
        (datum.hitRate > 0.5 && datum.hitRate <= 0.75)
    ) {
        anchor = 'start';
    } else {
        anchor = 'end';
    }
    return anchor;
}

/**
 * Calculates the vert anchor of a dot label.
 * @param datum {Object}
 * @returns {undefined|number}
 */
export function calculateVertAnchor(datum) {
    let anchor;

    if ((datum.payoffTransformed ?? null) === null) {
        return undefined;
    }

    if (
        datum.payoffTransformed <= 0.25 ||
        (datum.payoffTransformed > 0.5 && datum.payoffTransformed <= 0.75)
    ) {
        anchor = 'start';
    } else {
        anchor = 'end';
    }
    return anchor;
}
